import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const reviewsSlice = createSlice({
    name: 'reviews',
    initialState: {
        reviewTypes: [],
        isReviewTypesLoaded: false,
        reviewsList: [],
        reviewsSummary: {},
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(actions.getReviewerTypes.pending, (state) => {
            state.loading = true;
            state.isReviewTypesLoaded = false;
        });

        builder.addCase(actions.getReviewerTypes.fulfilled, (state, action) => {
            const { success, data } = action.payload || {};
            if (success) {
                state.reviewTypes = data;
                state.isReviewTypesLoaded = true;
            } else {
                state.reviewTypes = [];
                state.isReviewTypesLoaded = false;
            }
            state.loading = false;
        });

        builder.addCase(actions.getReviewerTypes.rejected, (state) => {
            state.loading = false;
            state.isReviewTypesLoaded = false;
        });

        // Paginated Reviews
        builder.addCase(actions.getProductReviews.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(actions.getProductReviews.fulfilled, (state, action) => {
            const { data, start } = action.payload || {}; // make sure your action returns 'start'
            
            if (start && start > 0) {
                // Append new reviews
                state.reviewsList = [...state.reviewsList, ...(data || [])];
            } else {
                // First load, replace list
                state.reviewsList = data || [];
            }

            state.loading = false;
        });
        builder.addCase(actions.getProductReviews.rejected, (state) => {
            state.reviewsList = []; 
            state.loading = false;
        });

         
    },

});

export default reviewsSlice.reducer;
